"use client";

import Arrow from "@/assets/svg/32/Arrow";
import useDesktopDrag from "@/lib/hooks/slider/useDesktopDrag";
import useSliderArrows from "@/lib/hooks/slider/useSliderArrows";
import clsx from "clsx";
import { useRef } from "react";
import styles from "./tabs-ui.module.css";

const CSSSlider = ({
	children,
	uuid,
	hideArrows = false,
}: {
	children: React.ReactNode;
	uuid: string | number;
	hideArrows?: boolean;
}) => {
	const scrollContainer = useRef<HTMLDivElement>(null!);

	const { scrollNext, scrollPrev, canScrollNext, canScrollPrev, showArrows } =
		useSliderArrows(scrollContainer);

	useDesktopDrag(scrollContainer);

	return (
		<section className={styles.carousel}>
			<div className={styles.inner}>
				<div
					className="scroll_container default_scroll"
					ref={scrollContainer}
					key={uuid}
				>
					{children}
				</div>
			</div>
			<div className={styles.gallery_button_wrapper}>
				{showArrows && !hideArrows && (
					<button
						title="previous"
						disabled={!canScrollPrev}
						onClick={(e) => {
							e.stopPropagation();
							scrollPrev();
						}}
						className={styles.gallery_button}
					>
						<Arrow />
					</button>
				)}
				{showArrows && !hideArrows && (
					<button
						title="next"
						disabled={!canScrollNext}
						onClick={(e) => {
							e.stopPropagation();
							scrollNext();
						}}
						className={clsx(styles.gallery_button, styles.right)}
					>
						<Arrow />
					</button>
				)}
			</div>
		</section>
	);
};

export default CSSSlider;
